import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { useTheme } from '../../contexts/ThemeContext';
import { useLocation } from 'react-router-dom';
import './BackgroundPattern.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [activeItem, setActiveItem] = useState('documents');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { darkMode } = useTheme();
  const location = useLocation();

  // Update active item based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path === '/dashboard') {
      setActiveItem('dashboard');
    } else if (path === '/data') {
      setActiveItem('data');
    } else if (path === '/usage') {
      setActiveItem('usage');
    } else if (path === '/' || path === '/documents') {
      setActiveItem('documents');
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className={`flex flex-col h-screen ${darkMode ? 'dark' : ''}`}>
      <div className="flex flex-col h-screen bg-background dark:bg-dark-background dark:text-dark-text">
        <Header />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar 
            activeItem={activeItem} 
            setActiveItem={setActiveItem} 
            collapsed={sidebarCollapsed}
            toggleCollapse={toggleSidebar}
          />
          <main className="flex-1 overflow-y-auto p-6 bg-dotted-pattern dark:bg-dark-background">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
